export default [
  {
    id: 1,
    key: 'paperUseAmount',
    name: '账面消耗金额',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      }, {
        label: '>',
        value: '>'
      }, {
        label: '<=',
        value: '<='
      }, {
        label: '<',
        value: '<'
      }
    ],
    unit: '元',
    fixed: true
  },
  {
    id: 2,
    key: 'amount',
    name: '实际消耗金额',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '元',
    fixed: true
  },
  {
    id: 3,
    key: 'downNum',
    name: '激活数',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '个',
    fixed: false
  },
  {
    id: 4,
    key: 'createRoleNum',
    name: '创角数',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '个',
    fixed: false
  },
  {
    id: 5,
    key: 'createRoleCost',
    name: '创角成本',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '元',
    fixed: true
  },
  {
    id: 6,
    key: 'activeCost',
    name: '激活成本',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '元',
    fixed: true
  },
  {
    id: 7,
    key: 'payRoleUserNum',
    name: '新增付费创角数',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '个',
    fixed: false
  },
  {
    id: 8,
    key: 'newRolePayCnt',
    name: '新创角付费次数',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '次',
    fixed: false
  },
  {
    id: 9,
    key: 'payRoleUserRate',
    name: '新创角付费率',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '%',
    fixed: true
  },
  {
    id: 10,
    key: 'newRoleRate',
    name: '新创角回款率',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '%',
    fixed: true
  },
  {
    id: 11,
    key: 'oneDayLtv',
    name: '1日创角LTV',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '',
    fixed: true
  },
  {
    id: 12,
    key: 'threeDayLtv',
    name: '3日创角LTV',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '',
    fixed: true
  },
  {
    id: 13,
    key: 'sevenDayLtv',
    name: '7日创角LTV',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '',
    fixed: true
  },
  {
    id: 14,
    key: 'fifteenDayLtv',
    name: '15日创角LTV',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '',
    fixed: true
  },
  {
    id: 15,
    key: 'thirtyDayLtv',
    name: '30日创角LTV',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '',
    fixed: true
  },
  {
    id: 16,
    key: 'sixtyDayLtv',
    name: '60日创角LTV',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '',
    fixed: true
  },
  {
    id: 17,
    key: 'nextDayRetainRate',
    name: '次日创角留存',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '%',
    fixed: true
  },
  {
    id: 18,
    key: 'threeDayRetainRate',
    name: '3日创角留存',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '%',
    fixed: true
  },
  {
    id: 19,
    key: 'sevenDayRetainRate',
    name: '7日创角留存',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '%',
    fixed: true
  },
  {
    id: 20,
    key: 'fifteenDayRetainRate',
    name: '15日创角留存',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '%',
    fixed: true
  },
  {
    id: 21,
    key: 'thirtyDayRetainRate',
    name: '30日创角留存',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '%',
    fixed: true
  },
  {
    id: 22,
    key: 'sixtyDayRetainRate',
    name: '60日创角留存',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '%',
    fixed: true
  },
  {
    id: 23,
    key: 'sumMoney',
    name: '激活总流水',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '元',
    fixed: true
  }
]
